import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import Paragraph from 'components/Paragraph';
import BaseCard from 'apps/notificationCenter/views/baseCard';

import { StyledLink } from 'legacyComponents/styled/lib';

const InviteActionedCard = props => {
  const { t, notification } = props;
  const { targetApp } = notification;
  const { status, groupTitle, groupSpaceType } = targetApp;
  if (!notification || !targetApp) return null;

  const spaceTypeName = {
    INITIATIVE: t('Organisation'),
    PROJECT: t('Project'),
    SHARED_FILE: t('File'),
  };

  const action =
    status === 'APPROVED' ? t('Joined your') : t('Chose not to join your');

  const message = (
    <Paragraph>
      {action} {spaceTypeName[groupSpaceType]}{' '}
      <strong>
        <StyledLink {...targetApp.route}>{groupTitle}</StyledLink>
      </strong>
      .
    </Paragraph>
  );

  return (
    <BaseCard notification={notification} message={message} isActionable />
  );
};

InviteActionedCard.propTypes = {
  t: PropTypes.func,
  notification: PropTypes.object,
  visible: PropTypes.bool,
};

export default withNamespaces()(observer(InviteActionedCard));
